import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/501applogo.webp'
import _imports_1 from '@/assets/web_iOS_download.webp'
import _imports_2 from '@/assets/web_mac_download.webp'
import _imports_3 from '@/assets/web_win_download.webp'
import _imports_4 from '@/assets/web_00.webp'


const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"container\"><div class=\"row justify-content-center pt-4\"><div class=\"col-md-3\"><img alt=\"Notik title\" class=\"applogo limit-w\" id=\"titlelogo\" src=\"" + _imports_0 + "\"></div></div><div class=\"row\"><p class=\"f0 mx-auto\">Notik</p><p> One notebook effortlessly holds work, life, and inspiration, making recording simple again </p></div><div class=\"row justify-content-center\"><div class=\"col-md-3\"><a href=\"https://apps.apple.com/app/notik/id6744988185\" target=\"_blank\"><img alt=\"iOS download\" src=\"" + _imports_1 + "\" class=\"downbutton limit-w mt-3\"></a></div><div class=\"col-md-3 align-items-center\"><a href=\"/files/Notik.Universal.dmg\" target=\"_blank\"><img alt=\"mac download\" src=\"" + _imports_2 + "\" class=\"downbutton limit-w mt-3\"></a><div class=\"text-center mt-3\" data-bs-toggle=\"modal\" data-bs-target=\"#VersionHistoryModal\" style=\"cursor:pointer;\"> Version History </div></div><div class=\"col-md-3\"><a href=\"/files/Notik.win.zip\" target=\"_blank\"><img alt=\"win download\" src=\"" + _imports_3 + "\" class=\"downbutton limit-w mt-3\"></a><div class=\"text-center mt-3\" data-bs-toggle=\"modal\" data-bs-target=\"#VersionHistoryModal\" style=\"cursor:pointer;\"> Version History </div></div></div><div class=\"row justify-content-center pt-5\"><img alt=\"app 00\" src=\"" + _imports_4 + "\" class=\"limit-w mt-3\"></div><div class=\"row\"><div class=\"mx-auto\"><div class=\"d-flex flex-column align-items-center mt-5 mb-3\"><div>service@notik.top</div><div><a href=\"https://www.freeprivacypolicy.com/live/9bd71ac2-9640-4b7f-ab37-5ad671480edf\" target=\"_blank\" class=\"no-underline\"><p style=\"color:#2a2a2a;\">privacy policy</p></a></div></div></div></div></div><div class=\"modal fade\" id=\"VersionHistoryModal\" tabindex=\"-1\" aria-labelledby=\"exampleModalLabel\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><h1 class=\"modal-title fs-5\" id=\"exampleModalLabel\"> Version History </h1><button type=\"button\" class=\"btn-close\" data-bs-dismiss=\"modal\" aria-label=\"Close\"></button></div><div class=\"modal-body\"><div class=\"col\"><div class=\"text-start\"> 1.0.1(2)<br>remember the currently selected page </div><div class=\"text-start mt-3\"> 1.0.1<br>Fixed a bug that prevented notes from syncing properly </div><div class=\"text-start mt-3\">1.0.0<br>Official Release</div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-secondary\" data-bs-dismiss=\"modal\"> Close </button></div></div></div></div>", 2)

import Viewer from "viewerjs";
import "viewerjs/dist/viewer.css";


import { defineComponent, reactive, ref } from "vue";

const __default__ = defineComponent({
  name: "HomeView",
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const showbv = ref(false);
const openurl = ref("");

function getHeight() {
  const clientHeight = document.documentElement.clientHeight;
  return clientHeight;
}

function openximage(s: string) {
  let eventView: any = reactive({ event: "" });
  eventView.event = new Viewer(document.getElementById(s) as HTMLElement, {
    navbar: true,
    title: false,
    toolbar: {
      zoomIn: 2,
      zoomOut: 1,
      // oneToOne: 1,
      // reset: 1,
      // prev: 1,
      // play: 0,
      // next: 1,
      // rotateLeft: 1,
      // rotateRight: 1,
      // flipHorizontal: 1,
      // flipVertical: 1,
    },
    show: function () {
      eventView.event.update();
    },
  });
  eventView.event.update();
}

return (_ctx: any,_cache: any) => {
  return _hoisted_1
}
}

})